import { UmFieldVariant } from './field-variant.js';

export interface UmFieldDefaults {
  variant: UmFieldVariant;
}
